import { QueryKey } from 'react-query';

export const queryKeys = {
  all: ['brand'],
  byId: (payload: { idOrRoute: string }): QueryKey => [...queryKeys.all, payload.idOrRoute],
};
